// @flow
import { getScreenStyles } from '../../../../utils'

export const Container = {
  width: '450px',
  display: 'flex',
  flexFlow: 'column nowrap',
}

export const Content = {
  flexGrow: 1,
  padding: '0 20px 20px 20px',
}

export const ButtonContainer = getScreenStyles(
  'xs',
  {
    display: 'flex',
    justifyContent: 'stretch',
    flexFlow: 'column nowrap',
    margin: '10px 0',
  },
  {
    margin: '10px 0',
    width: 'auto',
    flexGrow: '-1',
  }
)
